import React from "react";

/**
 * Modern Card Component
 */
const Card = ({
  children,
  title,
  subtitle,
  headerActions,
  className = "",
  shadow = "md",
  hover = true,
}) => {
  const shadowClasses = {
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg",
    xl: "shadow-xl",
  };

  const hoverClass = hover ? "hover:shadow-2xl transition-shadow duration-300" : "";

  return (
    <div
      className={`bg-white rounded-xl ${shadowClasses[shadow]} ${hoverClass} overflow-hidden ${className}`}
    >
      {(title || headerActions) && (
        <div className="border-b border-gray-200 p-4 bg-gradient-to-r from-gray-50 to-white">
          <div className="flex justify-between items-center">
            <div>
              {title && <h3 className="text-lg font-bold text-gray-800">{title}</h3>}
              {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
            </div>
            {headerActions && <div>{headerActions}</div>}
          </div>
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
};

export default Card;

